import { render } from "./ModalAddCustomer.vue?vue&type=template&id=43005096"
import script from "./ModalAddCustomer.vue?vue&type=script&lang=js"
export * from "./ModalAddCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__